/**
 * API Module - Handles data fetching and geolocation
 */

export const SUPPORTED_COUNTRIES = ['py'];

/**
 * Read embedded JSON data from the document when present.
 * @param {string} scriptId - The ID of the script tag containing the JSON string.
 * @returns {Object|null} The parsed JSON object, or null if not found/invalid.
 */
export function getEmbeddedData(scriptId) {
  const script = document.getElementById(scriptId);
  if (!script) return null;

  try {
    return JSON.parse(script.textContent);
  } catch (err) {
    console.warn(`Invalid embedded JSON in #${scriptId}`, err);
    return null;
  }
}

/**
 * Fetch news data for a specific date or today
 * @param {string} [dateParam='today'] - The date string ('YYYY-MM-DD') or 'today'.
 * @returns {Promise<Object>} The parsed JSON news data object.
 * @throws {Error} If the fetch request fails.
 */
export async function fetchNewsData(dateParam = 'today') {
  const path = (dateParam && dateParam !== 'today')
    ? `/historial/${dateParam}/news.json`
    : '/data/news.json';
  
  const response = await fetch(`${path}?t=${Date.now()}`);
  if (!response.ok) throw new Error(`Failed to fetch news data from ${path}`);
  return await response.json();
}

/**
 * Detect user country via GeoJS (or mocked to 'py')
 * @returns {Promise<string>} The lowercase country code.
 */
export async function detectCountry() {
  return 'py';
}

/**
 * Fetch search index
 * @returns {Promise<Object>} The parsed search index JSON object.
 */
export async function fetchSearchIndex() {
  const res = await fetch('/data/search-index.json');
  if (!res.ok) throw new Error('Search index not found');
  return await res.json();
}
